import {HttpRequest} from '../../../settings/HttpRequest/HttpRequest';

export const TipoCompraProductoService = {
	Listar: () => {
		let params = {};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Tipo_Compra_Datos', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Agregar: (form) => {
		let params = {
			id_cat_tipo_compra: null,
			id_cat_grupo_compra: form.id_cat_grupo_compra,
			tipo_compra: form.tipo_compra,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Tipo_Compra_Guardar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Modificar: (form) => {
		let params = {
			id_cat_tipo_compra: form.id_cat_tipo_compra,
			id_cat_grupo_compra: form.id_cat_grupo_compra,
			tipo_compra: form.tipo_compra,
			activo: form.activo ? 1 : 0
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Tipo_Compra_Modificar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	},
	Eliminar: (id_cat_tipo_compra) => {
		let params = {
			id_cat_tipo_compra: id_cat_tipo_compra
		};
		return new Promise((resolve, reject) => {
			HttpRequest.post('_Cat/_Tipo_Compra_Eliminar', params).then((response) => {
				resolve(response);
			}).catch((error) => {
				reject(error);
			});
		});
	}
};
